import {Oui} from './Oui';
export class UrlSecurite {

	public oui: Oui;

	public non: string;

	constructor() { 
		 		this.oui = new Oui();
		this.non = '';
 
	}
}
